import { render } from "./CreateCharterersRecord.vue?vue&type=template&id=64247b05&scoped=true"
import script from "./CreateCharterersRecord.vue?vue&type=script&lang=js"
export * from "./CreateCharterersRecord.vue?vue&type=script&lang=js"

import "./CreateCharterersRecord.vue?vue&type=style&index=0&id=64247b05&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64247b05"]])

export default __exports__